<template>
  <div
    data-cy="agent"
  >
    <p>Les coordonnées du conseiller Swiss Life en charge de votre demande :</p>
    <div
      data-cy="infos"
    >
      <span v-if="agent.libelleAgent">{{ agent.libelleAgent }}<br></span>
      <span v-if="agent.adresseAgent">{{ agent.adresseAgent }}<br></span>
      <span v-if="agent.cpAgent || agent.villeAgent">{{ agent.cpAgent }} {{ agent.villeAgent }}<br></span>
      <span v-if="agent.telAgent">Téléphone : {{ agent.telAgent }}<br></span>
      <span v-if="agent.emailAgent">Email : {{ agent.emailAgent }}<br></span>
      <span v-if="agent.numOriasAgent">Numéro Orias : {{ agent.numOriasAgent }}<br></span>
    </div>
  </div>
</template>

<script>
/**
 * Infos Agent
 * Un simple composant pour afficher les informations de l'agent
 */
export default {
  name: 'InfosAgent',
  props: {
    agent: {
      type: Object,
      required: true,
    }
  },
}
</script>

